const FONT_URL =
  "https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,600;9..144,700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap";

const THEME_COLOR = "#12283C";
const TITLE = "De cero a tu empresa de limpieza | Ebook + 8 bonos";
const DESCRIPTION =
  "Guía práctica para empezar tu negocio de limpieza desde cero: organizá tus servicios, calculá cuánto cobrar y conseguí tus primeros clientes. Ebook de 189 páginas + 8 bonos + kit en el celular.";

function addLink(attrs: Record<string, string>) {
  const link = document.createElement("link");
  Object.entries(attrs).forEach(([key, value]) => link.setAttribute(key, value));
  document.head.appendChild(link);
  return link;
}

function ensureMeta(name: string, content: string) {
  let meta = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = name;
    document.head.appendChild(meta);
  }
  meta.content = content;
}

/** Head setup + early resource hints. Runs before React renders, in priority order. */
export function addResourceHints(heroImage: string) {
  if (typeof document === "undefined") return;

  // Meta
  ensureMeta("theme-color", THEME_COLOR);
  if (!document.title) document.title = TITLE;
  ensureMeta("description", DESCRIPTION);

  // Preconnect to external origins
  addLink({ rel: "preconnect", href: "https://fonts.googleapis.com" });
  addLink({ rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "anonymous" });
  addLink({ rel: "preconnect", href: "https://cdn.magicpatterns.com" });
  // cdn.shopify.com preconnect removed: no resource on this landing loads from it
  // (checkout lives on deceroatuempresadelimpieza.com, kept below as dns-prefetch).

  // Checkout / tracking domains
  addLink({ rel: "dns-prefetch", href: "https://deceroatuempresadelimpieza.com" });
  addLink({ rel: "dns-prefetch", href: "https://connect.facebook.net" });

  // Hero image (LCP candidate)
  addLink({ rel: "preload", as: "image", href: heroImage, fetchpriority: "high" });

  // Async fonts: preload + onload swap to stylesheet (never render-blocking)
  const fonts = addLink({ rel: "preload", as: "style", href: FONT_URL });
  fonts.addEventListener(
    "load",
    () => {
      fonts.rel = "stylesheet";
    },
    { once: true }
  );
}

/** Run a non-critical task after DOMContentLoaded, when the main thread is idle. */
export function runWhenIdle(task: () => void) {
  if (typeof window === "undefined") return;
  const schedule = () => {
    const ric = (window as Window & { requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number })
      .requestIdleCallback;
    if (ric) {
      ric(task, { timeout: 2000 });
    } else {
      window.setTimeout(task, 200);
    }
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedule, { once: true });
  } else {
    schedule();
  }
}
